/*=========================================================================================
  File Name: moduleBrandState.js
  Description: Brand Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
